// import config from "@/config"
import { msTimestampFormat } from "@/utils"
export const autoDeployOption = [
    {
        label: "是",
        value: 1
    },
    {
        label: "否",
        value: 2
    }
]
export enum AutoDeploy {
    是 = 1,
    否
}
export const getColumns = (context: any) => {
    return [
        {
            title: "产品名称",
            dataIndex: "product_name",
            width: 250,
            filter: {
                type: "input"
            }
        },
        {
            title: "上架平台",
            dataIndex: "product_sub_type",
            width: 150,
            filter: {
                type: "select",
                options: context.product_sub_type,
                mode: "multiple"
            },
            customRender: (text: number) => {
                return context.productSubTypeMap[text] || "-"
            }
        },
        {
            title: "产品线",
            dataIndex: "software_name",
            width: 150,
            filter: {
                type: "select",
                optionsDynamic: "softwareList",
                mode: "multiple"
            }
            // renderProps: {
            //     onClick: (e: any) => {
            //         context.onView([e])
            //     }
            // },
            // renderType: "link"
        },
        {
            title: "文本类型",
            dataIndex: "text_type",
            width: 150,
            filter: {
                type: "select",
                options: context.privacy_policy_text_type,
                mode: "multiple"
            },
            customRender: (text: number) => {
                return context.textTypeMap[text] || "-"
            }
        },
        {
            title: "区域",
            dataIndex: "area",
            width: 150,
            filter: {
                type: "select",
                options: context.area,
                mode: "multiple"
            },
            customRender: (text: number) => {
                return context.areaMap[text] || "-"
            }
        },
        {
            title: "是否多端共用",
            dataIndex: "using_platforms",
            width: 150,
            customRender: (arr: []) => {
                const labels = arr.map(item => {
                    return context.productSubTypeMap[item] || "-"
                })
                return labels.join("|")
            }
        },

        {
            title: "政策对外链接",
            dataIndex: "policy_external_link",
            width: 240,
            filter: {
                type: "input"
            }
        }
    ]
}

export const LogColumns = [
    {
        title: "操作名称",
        dataIndex: "operate",
        key: "operate"
    },
    {
        title: "操作人",
        dataIndex: "operator",
        key: "operator",
        scopedSlots: { customRender: "user_content" }
    },
    {
        title: "操作时间",
        dataIndex: "operate_time",
        key: "operate_time",
        customRender: (text: number) => {
            return text ? msTimestampFormat(text) : "-"
        }
    },
    {
        title: "操作详情",
        dataIndex: "operate_content",
        key: "operate_content",
        ellipsis: true,
        scopedSlots: { customRender: "change_content" }
    }
]

export const detailInfo = [
    [
        {
            label: "项目",
            type: "text",
            value: "software_name",
            span: 12
        },
        {
            label: "产品",
            type: "text",
            value: "product_name",
            span: 12
        }
    ],
    [
        {
            label: "文本类型",
            type: "text",
            value: "text_type",
            span: 12
        },
        {
            label: "区域",
            type: "text",
            value: "area",
            span: 12
        }
    ],
    [
        {
            label: "同步方式",
            type: "text",
            value: "sync_way",
            span: 12
        },
        {
            label: "自动部署",
            type: "text",
            value: "auto_deploy",
            span: 12
        }
    ],
    [
        {
            label: "政策对外链接",
            type: "link",
            value: "policy_external_link",
            span: 24
        }
    ],
    [
        {
            label: "内部服务链接",
            type: "link",
            value: "inner_service_link",
            span: 24
        }
    ]
]
